/* Beanie Boos – free shipping progress bar for the bag drawer and the bag page.
   Settings come from window.bbFreeShip (set in sections/bb-header-style.liquid). */
(function () {
  var cfg = window.bbFreeShip;
  if (!cfg || window.bbFreeShipReady) return;
  window.bbFreeShipReady = true;
  if (cfg.currency && cfg.shopCurrency && cfg.currency !== cfg.shopCurrency) return; /* threshold is in AUD */

  var total = Number(cfg.total) || 0;
  var timer = null;

  function money(cents) {
    var dollars = cents / 100;
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: cfg.currency || 'AUD',
        minimumFractionDigits: dollars % 1 === 0 ? 0 : 2
      }).format(dollars);
    } catch (e) {
      return '$' + dollars.toFixed(2);
    }
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'bb-fs';
    el.innerHTML =
      '<p class="bb-fs__msg" aria-live="polite"></p>' +
      '<div class="bb-fs__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="Progress to free shipping">' +
      '<span class="bb-fs__fill"></span></div>';
    return el;
  }

  function update(el) {
    var left = Math.max(cfg.threshold - total, 0);
    var pct = Math.min(100, Math.round((total / cfg.threshold) * 100));
    var msg = el.querySelector('.bb-fs__msg');
    var track = el.querySelector('.bb-fs__track');
    el.classList.toggle('bb-fs--done', left === 0);
    el.hidden = total <= 0;
    if (left === 0) {
      msg.textContent = cfg.reached;
    } else {
      var parts = String(cfg.away).split('[amount]');
      msg.textContent = '';
      msg.appendChild(document.createTextNode(parts[0]));
      if (parts.length > 1) {
        var b = document.createElement('strong');
        b.textContent = money(left);
        msg.appendChild(b);
        msg.appendChild(document.createTextNode(parts.slice(1).join(money(left))));
      }
    }
    track.setAttribute('aria-valuenow', String(pct));
    el.querySelector('.bb-fs__fill').style.width = pct + '%';
  }

  /* Where the bar goes: under the drawer heading, and under the bag page heading */
  function spots() {
    var list = [];
    var drawerHead = document.querySelector('cart-drawer .drawer__header');
    if (drawerHead) list.push(drawerHead);
    var pageHead = document.querySelector('cart-items .title-wrapper-with-link');
    if (pageHead) list.push(pageHead);
    return list;
  }

  function place() {
    spots().forEach(function (anchor) {
      var next = anchor.nextElementSibling;
      var el = next && next.classList.contains('bb-fs') ? next : null;
      if (!el) {
        el = build();
        anchor.insertAdjacentElement('afterend', el);
      }
      update(el);
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { total = Number(cart.total_price) || 0; place(); })
        .catch(place);
    }, 150);
  }

  function watch(node) {
    if (!node) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.closest && t.closest('.bb-fs')) continue;
        place();
        refresh();
        return;
      }
    }).observe(node, { childList: true, subtree: true });
  }

  /* Update straight after any add, change or remove (faster than waiting for the drawer to redraw) */
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var p = nativeFetch.apply(this, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (res) {
          /* change/update replies include the new cart total, so use it straight away */
          res.clone().json().then(function (data) {
            if (data && typeof data.total_price === 'number') { total = data.total_price; place(); }
            else refresh();
          }, refresh);
        }, function () {});
      }
      return p;
    };
  }

  function init() {
    place();
    watch(document.querySelector('cart-drawer'));
    watch(document.querySelector('cart-items'));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
